
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AssociateClientTeamsRequest,
  BillingContactUpdateRequest,
  ClientTeamsResource,
  LegalEntityBillingContactResource,
  LegalEntityDetailsResource,
  LegalEntityPreferencesRequest,
  LegalEntityPreferencesResource,
  LegalEntityRequest,
  LegalEntityResource,
  LegalEntitySummaryResource,
  LegalEntityWithClientTeamsRequest,
  ProjectTermsAndConditionsResource,
  TeamLegalEntityAssociationResource,
} from '../models';
import {
    AssociateClientTeamsRequestFromJSON,
    AssociateClientTeamsRequestToJSON,
    BillingContactUpdateRequestFromJSON,
    BillingContactUpdateRequestToJSON,
    ClientTeamsResourceFromJSON,
    ClientTeamsResourceToJSON,
    LegalEntityBillingContactResourceFromJSON,
    LegalEntityBillingContactResourceToJSON,
    LegalEntityDetailsResourceFromJSON,
    LegalEntityDetailsResourceToJSON,
    LegalEntityPreferencesRequestFromJSON,
    LegalEntityPreferencesRequestToJSON,
    LegalEntityPreferencesResourceFromJSON,
    LegalEntityPreferencesResourceToJSON,
    LegalEntityRequestFromJSON,
    LegalEntityRequestToJSON,
    LegalEntityResourceFromJSON,
    LegalEntityResourceToJSON,
    LegalEntitySummaryResourceFromJSON,
    LegalEntitySummaryResourceToJSON,
    LegalEntityWithClientTeamsRequestFromJSON,
    LegalEntityWithClientTeamsRequestToJSON,
    ProjectTermsAndConditionsResourceFromJSON,
    ProjectTermsAndConditionsResourceToJSON,
    TeamLegalEntityAssociationResourceFromJSON,
    TeamLegalEntityAssociationResourceToJSON,
} from '../models';

export interface AssociateClientTeamsOperationRequest {
    legalEntityId: string;
    associateClientTeamsRequest: AssociateClientTeamsRequest;
}

export interface CreateRequest {
    legalEntityRequest: LegalEntityRequest;
}

export interface CreateWithClientTeamsRequest {
    legalEntityWithClientTeamsRequest: LegalEntityWithClientTeamsRequest;
}

export interface FindAllClientTeamsRequest {
    legalEntityId: string;
}

export interface FindAllOrganizationClientTeamsRequest {
    organizationId: string;
}

export interface FindAllSummariesByOrganizationIdRequest {
    organizationId: string;
}

export interface FindDetailsByIdRequest {
    legalEntityId: string;
}

export interface FindPreferencesByIdRequest {
    legalEntityId: string;
}

export interface FindTeamLegalEntitiesRequest {
    clientTeamId: string;
}

export interface SetDefaultLegalEntityForClientTeamRequest {
    clientTeamId: string;
    legalEntityId: string;
}

export interface UpdateDetailsRequest {
    legalEntityId: string;
    billingContactUpdateRequest: BillingContactUpdateRequest;
}

export interface UpdatePreferencesRequest {
    legalEntityId: string;
    legalEntityPreferencesRequest: LegalEntityPreferencesRequest;
}

export interface UpdateTeamRequest {
    clientTeamId: string;
    legalEntityRequest: LegalEntityRequest;
}

/**
 * 
 */
export class ClientLegalEntityApi extends runtime.BaseAPI {

    /**
     * Associate client teams to a legal entity
          */
    async associateClientTeamsRaw(requestParameters: AssociateClientTeamsOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling associateClientTeams().'
            );
        }

        if (requestParameters['associateClientTeamsRequest'] == null) {
            throw new runtime.RequiredError(
                'associateClientTeamsRequest',
                'Required parameter "associateClientTeamsRequest" was null or undefined when calling associateClientTeams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/legal-entities/{legalEntityId}/client-teams`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssociateClientTeamsRequestToJSON(requestParameters['associateClientTeamsRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Associate client teams to a legal entity
          */
    async associateClientTeams(requestParameters: AssociateClientTeamsOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.associateClientTeamsRaw(requestParameters, initOverrides);
    }

    /**
     * Create a legal entity
          */
    async createRaw(requestParameters: CreateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LegalEntityResource>> {
        if (requestParameters['legalEntityRequest'] == null) {
            throw new runtime.RequiredError(
                'legalEntityRequest',
                'Required parameter "legalEntityRequest" was null or undefined when calling create().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<LegalEntityResource>({
            path: `/client-settings/api/legal-entities`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LegalEntityRequestToJSON(requestParameters['legalEntityRequest']),
        }, initOverrides);

        if (response._data) { response._data=LegalEntityResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create a legal entity
          */
    async create(requestParameters: CreateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LegalEntityResource> {
        const response = await this.createRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Create a legal entity with associated client teams
          */
    async createWithClientTeamsRaw(requestParameters: CreateWithClientTeamsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LegalEntityResource>> {
        if (requestParameters['legalEntityWithClientTeamsRequest'] == null) {
            throw new runtime.RequiredError(
                'legalEntityWithClientTeamsRequest',
                'Required parameter "legalEntityWithClientTeamsRequest" was null or undefined when calling createWithClientTeams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<LegalEntityResource>({
            path: `/client-settings/api/organizations/{organizationId}/legal-entities-with-client-teams`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LegalEntityWithClientTeamsRequestToJSON(requestParameters['legalEntityWithClientTeamsRequest']),
        }, initOverrides);

        if (response._data) { response._data=LegalEntityResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create a legal entity with associated client teams
          */
    async createWithClientTeams(requestParameters: CreateWithClientTeamsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LegalEntityResource> {
        const response = await this.createWithClientTeamsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Find all client teams of a legal entity
          */
    async findAllClientTeamsRaw(requestParameters: FindAllClientTeamsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientTeamsResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling findAllClientTeams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientTeamsResource>({
            path: `/client-settings/api/legal-entities/{legalEntityId}/client-teams`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientTeamsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Find all client teams of a legal entity
          */
    async findAllClientTeams(requestParameters: FindAllClientTeamsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientTeamsResource> {
        const response = await this.findAllClientTeamsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Find all client teams of an organization
          */
    async findAllOrganizationClientTeamsRaw(requestParameters: FindAllOrganizationClientTeamsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientTeamsResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling findAllOrganizationClientTeams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientTeamsResource>({
            path: `/client-settings/api/organizations/{organizationId}/client-teams`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientTeamsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Find all client teams of an organization
          */
    async findAllOrganizationClientTeams(requestParameters: FindAllOrganizationClientTeamsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientTeamsResource> {
        const response = await this.findAllOrganizationClientTeamsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Find all legal entity summaries of an organization
          */
    async findAllSummariesByOrganizationIdRaw(requestParameters: FindAllSummariesByOrganizationIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<LegalEntitySummaryResource>>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling findAllSummariesByOrganizationId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<LegalEntitySummaryResource>>({
            path: `/client-settings/api/organizations/{organizationId}/legal-entity-summaries`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(LegalEntitySummaryResourceFromJSON);
        return response;
    }

    /**
     * Find all legal entity summaries of an organization
          */
    async findAllSummariesByOrganizationId(requestParameters: FindAllSummariesByOrganizationIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<LegalEntitySummaryResource>> {
        const response = await this.findAllSummariesByOrganizationIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get legal entity details by id
          */
    async findDetailsByIdRaw(requestParameters: FindDetailsByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LegalEntityDetailsResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling findDetailsById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<LegalEntityDetailsResource>({
            path: `/client-settings/api/legal-entities/{legalEntityId}`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=LegalEntityDetailsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get legal entity details by id
          */
    async findDetailsById(requestParameters: FindDetailsByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LegalEntityDetailsResource> {
        const response = await this.findDetailsByIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Find legal entity preferences by id
          */
    async findPreferencesByIdRaw(requestParameters: FindPreferencesByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LegalEntityPreferencesResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling findPreferencesById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<LegalEntityPreferencesResource>({
            path: `/client-settings/api/legal-entities/{legalEntityId}/preferences`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=LegalEntityPreferencesResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Find legal entity preferences by id
          */
    async findPreferencesById(requestParameters: FindPreferencesByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LegalEntityPreferencesResource> {
        const response = await this.findPreferencesByIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Find the legal entities associated with a client team, and its default one
          */
    async findTeamLegalEntitiesRaw(requestParameters: FindTeamLegalEntitiesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<TeamLegalEntityAssociationResource>> {
        if (requestParameters['clientTeamId'] == null) {
            throw new runtime.RequiredError(
                'clientTeamId',
                'Required parameter "clientTeamId" was null or undefined when calling findTeamLegalEntities().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<TeamLegalEntityAssociationResource>({
            path: `/client-settings/api/client-teams/{clientTeamId}/legal-entities`.replace(`{${"clientTeamId"}}`, encodeURIComponent(String(requestParameters['clientTeamId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=TeamLegalEntityAssociationResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Find the legal entities associated with a client team, and its default one
          */
    async findTeamLegalEntities(requestParameters: FindTeamLegalEntitiesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<TeamLegalEntityAssociationResource> {
        const response = await this.findTeamLegalEntitiesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve last project terms and conditions reference
          */
    async getLastProjectTermsAndConditionsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectTermsAndConditionsResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectTermsAndConditionsResource>({
            path: `/client-settings/api/legal-entities/project-terms-and-conditions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectTermsAndConditionsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve last project terms and conditions reference
          */
    async getLastProjectTermsAndConditions(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectTermsAndConditionsResource> {
        const response = await this.getLastProjectTermsAndConditionsRaw(initOverrides);
        return response._data;
    }

    /**
     * Set the default legal entity for a client team
          */
    async setDefaultLegalEntityForClientTeamRaw(requestParameters: SetDefaultLegalEntityForClientTeamRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['clientTeamId'] == null) {
            throw new runtime.RequiredError(
                'clientTeamId',
                'Required parameter "clientTeamId" was null or undefined when calling setDefaultLegalEntityForClientTeam().'
            );
        }

        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling setDefaultLegalEntityForClientTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/client-settings/api/client-teams/{clientTeamId}/legal-entities/{legalEntityId}/default`.replace(`{${"clientTeamId"}}`, encodeURIComponent(String(requestParameters['clientTeamId']))).replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Set the default legal entity for a client team
          */
    async setDefaultLegalEntityForClientTeam(requestParameters: SetDefaultLegalEntityForClientTeamRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.setDefaultLegalEntityForClientTeamRaw(requestParameters, initOverrides);
    }

    /**
     * Update legal entity details
          */
    async updateDetailsRaw(requestParameters: UpdateDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LegalEntityBillingContactResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling updateDetails().'
            );
        }

        if (requestParameters['billingContactUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'billingContactUpdateRequest',
                'Required parameter "billingContactUpdateRequest" was null or undefined when calling updateDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<LegalEntityBillingContactResource>({
            path: `/client-settings/api/legal-entities/{legalEntityId}`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BillingContactUpdateRequestToJSON(requestParameters['billingContactUpdateRequest']),
        }, initOverrides);

        if (response._data) { response._data=LegalEntityBillingContactResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Update legal entity details
          */
    async updateDetails(requestParameters: UpdateDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LegalEntityBillingContactResource> {
        const response = await this.updateDetailsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update legal entity preferences
          */
    async updatePreferencesRaw(requestParameters: UpdatePreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LegalEntityPreferencesResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling updatePreferences().'
            );
        }

        if (requestParameters['legalEntityPreferencesRequest'] == null) {
            throw new runtime.RequiredError(
                'legalEntityPreferencesRequest',
                'Required parameter "legalEntityPreferencesRequest" was null or undefined when calling updatePreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<LegalEntityPreferencesResource>({
            path: `/client-settings/api/legal-entities/{legalEntityId}/preferences`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LegalEntityPreferencesRequestToJSON(requestParameters['legalEntityPreferencesRequest']),
        }, initOverrides);

        if (response._data) { response._data=LegalEntityPreferencesResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Update legal entity preferences
          */
    async updatePreferences(requestParameters: UpdatePreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LegalEntityPreferencesResource> {
        const response = await this.updatePreferencesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update a legal entity information inside the client team
     
     * @deprecated
          */
    async updateTeamRaw(requestParameters: UpdateTeamRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['clientTeamId'] == null) {
            throw new runtime.RequiredError(
                'clientTeamId',
                'Required parameter "clientTeamId" was null or undefined when calling updateTeam().'
            );
        }

        if (requestParameters['legalEntityRequest'] == null) {
            throw new runtime.RequiredError(
                'legalEntityRequest',
                'Required parameter "legalEntityRequest" was null or undefined when calling updateTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/client-teams/{clientTeamId}/legal-entities`.replace(`{${"clientTeamId"}}`, encodeURIComponent(String(requestParameters['clientTeamId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LegalEntityRequestToJSON(requestParameters['legalEntityRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update a legal entity information inside the client team
     
     * @deprecated
          */
    async updateTeam(requestParameters: UpdateTeamRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTeamRaw(requestParameters, initOverrides);
    }

}
